import React from "react";
import Table from "../../common-components/table/table";
import { getTableData } from "./helpers";
import { IGetHiringsData } from "../../../../../services/ClientsDashboardServices.dto";

const HiringsTableRatio = ({ data }: { data: IGetHiringsData }) => {
  const { headRow, bodyRows, footerRow } = getTableData(data, true);

  return <Table headRow={headRow} bodyRows={bodyRows} footerRow={footerRow} />;
};

export default HiringsTableRatio;
